function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
import * as React from 'react';
import { SelectTheme } from 'common/components/select/constants';
import { SelectReact } from 'common/components/select';
import { isCohortSegment, SegmentValue } from 'common/query-builder/query-block/segment-menu/types';
import { isDateRangeProfileHistoryOptions, ProfileHistoryType, ProfileHistoryTypeToDisplayName, Segmentation } from 'common/types/reports/query';
import { ButtonSize, ButtonTheme } from 'common/components/button/constants';
import { SelectAttrs } from 'common/components/select/types';
import { DateRange } from 'common/widgets/date-range-picker/models/date-range';
import { TimeQueryBlock } from 'common/query-builder/query-block/time-menu/time-query-block';
import { ControlBarAction, ControlBarActionItems } from '../constants';
import { SelectorTypeDefinitions } from '../types';

/**
 * Renders profile history controls for a given Segmentation entry on filters or breakdowns
 */
export function ProfileHistorySubItem(props: {
  value: SegmentValue;
  onTypeChange: (newValue: SegmentValue) => void;
  hasNewUI: boolean;
  hideEvents: boolean;
  selectorType: SelectorTypeDefinitions;
}) {
  var _segmentation$profile, _segmentation$profile2;
  if (!props.value || isCohortSegment(props.value) || ![SelectorTypeDefinitions.Filter, SelectorTypeDefinitions.Segment].includes(props.selectorType)) {
    return null;
  }
  const segmentation = props.value as Segmentation;
  const currentType = (_segmentation$profile = (_segmentation$profile2 = segmentation.profileHistoryOptions) === null || _segmentation$profile2 === void 0 ? void 0 : _segmentation$profile2.type) !== null && _segmentation$profile !== void 0 ? _segmentation$profile : ProfileHistoryType.Latest;

  // Render a date selector to specify the time range
  if (isDateRangeProfileHistoryOptions(segmentation.profileHistoryOptions)) {
    return <div className='subitem-text'>
        <TimeQueryBlock className='subitem-style' theme={props.hasNewUI ? ButtonTheme.QbSubitem : ButtonTheme.Select} buttonSize={props.hasNewUI ? ButtonSize.Small : ButtonSize.Medium} selected={segmentation.profileHistoryOptions.dateRange} leftIcon='calendar' onSelect={(selection: DateRange) => {
        props.onTypeChange(_objectSpread(_objectSpread({}, segmentation), {}, {
          profileHistoryOptions: {
            type: ProfileHistoryType.DateRange,
            dateRange: selection.getAttributes()
          }
        }));
      }} />
      </div>;
  }
  const displayName = ProfileHistoryTypeToDisplayName[currentType];
  let displaySpecificAttrs: Partial<SelectAttrs>;
  if (props.hasNewUI) {
    displaySpecificAttrs = {
      theme: SelectTheme.QbSubitem,
      label: "Profile history type changed to **".concat(displayName, "**"),
      size: ButtonSize.Small
    };
  } else {
    displaySpecificAttrs = {
      theme: SelectTheme.Select,
      label: displayName
    };
  }
  const showMenu = props.hideEvents ? currentType !== ProfileHistoryType.Latest : currentType !== ProfileHistoryType.EventTime;
  return <>
      {showMenu && <div className='subitem-text'>
          <SelectReact className='subitem-select' {...displaySpecificAttrs} menuWidth={null} neverShowCaret elref='profileHistorySubitem' sections={ControlBarActionItems[ControlBarAction.ProfileHistory]({
        currentProfileHistoryType: currentType,
        hideEvents: props.hideEvents,
        selectorType: props.selectorType
      }).subSections} onChange={(ev: CustomEvent) => {
        props.onTypeChange(_objectSpread(_objectSpread({}, segmentation), {}, {
          profileHistoryOptions: {
            type: ev.detail.item.value.toType
          }
        }));
      }} />
        </div>}
    </>;
}